<div class="data-collection-path__container">
    <a [href]="$state.href('^.home')"
    class="data-collection-path__inactive-part"
    >Data Collections</a>
    <i class="dku-icon-chevron-right-16"></i>
    <a [href]="$state.href('^.datacollection', {dataCollectionId: id})"
    class="data-collection-path__active-part"
    >{{displayName}}</a>
</div>
